<fieldset>
    <legend>SilverScript Information</legend>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Login ID'" (onValueChange)="personalDetails.UserProfileName = $event"
                    [disabled]="disableLogIn" [text]="personalDetails.UserProfileName" maxlength="20">
                </ValidatedTextField>
            </div>
        </div>
        @if (!isAddMode) {
        <div class="col-8" id="divChangePwd">
            <div class="input-wrapper">
                <a (click)="changePwdNavigation()" class="change-password">Change Password</a>
            </div>
        </div>
        }

        <div class="col-8" *ngIf="isAddMode">
            <div class="input-wrapper">
                <div>
                    <ValidatedTextField class="field" id="password" label="Password"
                        [text]="personalDetails.LoginPassword" type="password"
                        (onValueChange)="personalDetails.LoginPassword = $event">
                    </ValidatedTextField>
                    <!--<label>Password</label>
                    <ObfuscatedTextField (onValueChange)="personalDetails.LoginPassword = $event"
                                         fieldId="pwd"
                                         [text]="personalDetails.LoginPassword">
                    </ObfuscatedTextField>-->
                </div>
            </div>
        </div>
        <div class="col-8" *ngIf="isAddMode">
            <div class="instructions-list">
                <strong>The password must:</strong>
                <ul>
                    <li>Be a minimum length of 12 characters</li>
                    <li>Contain at least 1 upper-case letter</li>
                    <li>Contain at least 1 lower-case letter</li>
                    <li>Contain at least 1 special non-alpha-character</li>
                    <li>Contain at least 1 number</li>
                    <li>No character can occur 3 times consecutively</li>
                    <li>You cannot re-use any of your previous 8 passwords</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row" id="divUserTypeAndOrg">
        <!--<div class="col-8">
            <div class="input-wrapper">
            <Label for="Organization">Organization</Label>
            <jq-org-dropdown (onValueChange)="OnOrgSelected($event)" #child></jq-org-dropdown>
        </div>

    </div>-->
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedDropDown class="wide" [label]="'User Type'" [options]="_userType"
                    [selectedValue]="personalDetails.RoleID" (onValueChange)="OnUserTypeSelected($event)">
                </ValidatedDropDown>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-6" id="divEmpID" *ngIf="displayEmpID">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Employee ID'" [text]="personalDetails.UID"
                    (onValueChange)="personalDetails.UID = $event" maxlength="7">
                </ValidatedTextField>
            </div>
        </div>
    </div>
</fieldset>

<div class="row">
    <org-view (orgAdded)="onOrgSelectedFromView($event)" [orgSelected]="orgSelected"
        [hideBrowseView]="isOrgSelectHidden"></org-view>
</div>


<fieldset>
    <legend>Personal Information</legend>
    <div class="row">
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'First Name'" [text]="personalDetails.FirstName" [disabled]="controlMode"
                    [validators]="[notBlankValidator]" (onValueChange)="personalDetails.FirstName = $event"
                    maxlength="50">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-4">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Middle Name'" [disabled]="noMiddleName"
                    [text]="personalDetails.MiddleName" (onValueChange)="personalDetails.MiddleName = $event">

                </ValidatedTextField>
            </div>
        </div>
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Last Name'" [disabled]="controlMode" [text]="personalDetails.LastName"
                    [validators]="[notBlankValidator]" (onValueChange)="personalDetails.LastName = $event"
                    maxlength="50">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedCheckbox class="centered-checkbox" [disabled]="controlMode" [id]="'no-middle-name'"
                    [label]="'No Middle Name'" [checked]="personalDetails.isNoMidNameChecked"
                    (onValueChange)="personalDetails.isNoMidNameChecked= $event" (click)="clickOnMiddleName()">
                </ValidatedCheckbox>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField class="field" [label]="'Email'" id="email" [text]="personalDetails.Email"
                    (onValueChange)="personalDetails.Email = $event" [validators]="[notBlankValidator]" maxlength="150">
                </ValidatedTextField>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6" style="display:none" id="divDOB">
            <div class="input-wrapper">
                <ValidatedTextField class="field" [label]="'Date of Birth'" id="DOB"
                    [text]="personalDetails.BirthdateDecrypted" [disabled]="controlMode">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    @if (!isAddMode && !isAgentMode) {
    <div id="divBgAndStatus">
        <div class="row">
            <div class="col-16" id="divBG">
                <p class="detail-info">
                    Background questionnaire completed?

                    <span>{{ personalDetails.BGCheck }}</span>
                    <span>{{ personalDetails.BackGroundCheckDateStr }} </span>
                </p>
            </div>
        </div>
        <div class="row" id="divStatus">
            <div class="col-5">
                <div class="input-wrapper">
                    <ValidatedDropDown class="wide" [label]="'Background check result'"
                        [disabled]="isBackGroundDisabled" [options]="bgChkResult"
                        [selectedValue]="personalDetails.BgApproved" (onValueChange)="OnBgCheckChanged($event)">
                    </ValidatedDropDown>
                </div>
            </div>
            <div class="col-3">
                <div class="input-wrapper">
                    <p class="top-padding"> {{ BgChkResultDate }}</p>
                </div>
            </div>

            <div class="col-4">
                <div class="input-wrapper">
                    <ValidatedDropDown class="wide" [label]="'User Status'" [disabled]="isStatusDisabled"
                        [options]="userprofileStatus" [selectedValue]="personalDetails.UserProfileStatusId"
                        (onValueChange)="OnStatusChange($event)">
                    </ValidatedDropDown>
                </div>
            </div>
            <div id="divStatusreason" style="display:none" class="col-4">
                <div class="input-wrapper">
                    <ValidatedDropDown [label]="'Status Reason'" [disabled]="'false'" [options]="statusReason"
                        [selectedValue]="personalDetails.UserProfileStatusReason"
                        (onValueChange)="personalDetails.UserProfileStatusReason=$event">
                    </ValidatedDropDown>
                </div>
            </div>
        </div>
        <div class="row" id="divSSNDOB" *ngIf="dispSSNDOB">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Social Security Number'" id="SSN" [text]="personalDetails.SSN"
                        [maxlength]="9" (onValueChange)="personalDetails.SSN = $event"
                        [validators]="[notBlankValidator, lengthValidator, numericValidator]">
                    </ValidatedTextField>
                    * Please only enter numbers and no hyphens.
                </div>
            </div>

            <div class="col-4">
                <div class="input-wrapper">
                    <ValidatedDateTextField [label]="'Date of Birth'" id="dateofBirth"
                        [date]="personalDetails.dateofBirth" (onDateChange)="personalDetails.dateofBirth = $event"
                        [validators]="[validatedDate,notBlankValidator]">
                    </ValidatedDateTextField>
                </div>
            </div>

        </div>
    </div>
    }
</fieldset>